import { useEffect, useState, useContext } from "react";
import { VIDEO_SHARE_BTN_CLICK } from "../../../../AppConstants/AnalyticsEventName";
import InviteModal from "../../../../components/InviteModal/InviteModal";
import { Loader } from "../../../../components/RestrictedMessage/RestrictedMessage";
import EpisodesTab from "../../../../components/VideoDetails/partials/EpisodesTab";
import { AnalyticsContext } from "../../../../contexts/Analytics/AnalyticsContextProvider";
import { videoContext } from "../../../../contexts/VideoContext/VideoContextProvider";
import { FEATURED_VIDEO_CLICK_EVENT } from "../../../../Clevertap/EventNames.ts";
import { getStandaloneVideoData } from "../../../../Clevertap/EventHandler.ts";
import { ContentType2 } from "../../../../AppConstants/TypeConstants.js";

const FeaturedVideos = ({ baseInfo }) => {
  const [videos, setVideos] = useState(null);
  const { addGAWithUserInfo, addCleverTapAnalytics } = useContext(AnalyticsContext);
  const [showInviteModal, setShowInviteModal] = useState(false);
  const [restrictedVideo, setRestrictedVideo] = useState(false);

  const [currentVideoShare, setCurrentVideoShare] = useState(null);

  const { getMultipleVideosData } = useContext(videoContext);


  useEffect(() => {
    if (showInviteModal) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
  
    return () => {
      document.body.style.overflow = "auto"; // Clean up on unmount
    };
  }, [showInviteModal]);
  
  useEffect(() => {
    if (baseInfo && baseInfo.featured) {
      getVideos();
    }
  }, [baseInfo]);

  const getVideos = async () => {
    let _res = [];
    if (baseInfo.featured.length > 0) {
      try {
        _res = await getMultipleVideosData(baseInfo.featured);
      } catch (error) {
        _res = [];
      }
    }
    setVideos(_res);
  };

  const handleInviteBtn = (episode) => {
    setCurrentVideoShare(episode);
    addClickAnalytics(VIDEO_SHARE_BTN_CLICK, episode);
    setShowInviteModal(true);
  };

  const handleInviteBtnClose = () => {
    setShowInviteModal(false);
  };

  const addClickAnalytics = (eventName, episode) => {
    if (episode) {
      addCleverTapAnalytics(FEATURED_VIDEO_CLICK_EVENT, { 'Webinar ID': baseInfo.id, ...getStandaloneVideoData(episode) })
      addGAWithUserInfo(eventName, { eventId: episode.id });
    }
  };

  return !!videos ? (
    <>
      <EpisodesTab
        episodes={videos}
        setRestrictedVideo={setRestrictedVideo}
        handleInviteBtn={handleInviteBtn}
        setCurrentVideoShare={setCurrentVideoShare}
        addClickAnalytics={addClickAnalytics}
      />
      {showInviteModal && (
        <InviteModal
          from={ContentType2["Standalone Video"]}
          type="ott"
          details={currentVideoShare}
          handleClose={handleInviteBtnClose}
          customClass={"inviteModal"}
        />
      )}
    </>
  ) : (
    <Loader />
  );
};

export default FeaturedVideos;
